// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Floating Calendar Widget === */

.FloatingCalendar_iconButton__CUlpI {
  position: fixed;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #181a1b;
  border: 1px solid #444;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  z-index: 1000;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
  transition: left 0.32s cubic-bezier(0.22, 1, 0.36, 1),
              top 0.32s cubic-bezier(0.22, 1, 0.36, 1),
              box-shadow 0.2s ease, background-color 0.2s ease;
}

.FloatingCalendar_iconButton__CUlpI:hover {
  background-color: #23272a;
  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.35);
}

.FloatingCalendar_iconButton__CUlpI:active,
.FloatingCalendar_dragging__XCiMU {
  cursor: grabbing;
  transition: none; /* keine Transition waehrend des Ziehens */
}

.FloatingCalendar_iconButton__CUlpI:focus-visible {
  outline: 2px solid #4a9eff;
  outline-offset: 2px;
}

.FloatingCalendar_icon__OY7cs {
  font-size: 22px;
  line-height: 1;
  pointer-events: none;
}

.FloatingCalendar_iconBadge__sc3Cg {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background-color: #4a9eff;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border: 2px solid #181a1b;
}

/* === Calendar Panel === */

.FloatingCalendar_panel__b-axX {
  position: fixed;
  z-index: 1001;
  width: 340px;
  background-color: #181a1b;
  border: 1px solid #444;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.75);
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  overflow: hidden;
  animation: FloatingCalendar_popIn__nmZJK 0.16s ease-out;
}

@keyframes FloatingCalendar_popIn__nmZJK {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
}

.FloatingCalendar_panelHeader__9hw2N {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background-color: #23272a;
  border-bottom: 1px solid #444;
}

.FloatingCalendar_monthNav__L1Htn {
  display: flex;
  align-items: center;
  gap: 8px;
}

.FloatingCalendar_navButton__\\+Ye9E {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid transparent;
  background-color: transparent;
  color: #cccccc;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.FloatingCalendar_navButton__\\+Ye9E:hover {
  background-color: #3a3d42;
  color: #ffffff;
}

.FloatingCalendar_monthTitle__X27KY {
  font-size: 15px;
  font-weight: 600;
  min-width: 150px;
  text-align: center;
  text-transform: capitalize;
}

.FloatingCalendar_closeButton__Tpw67 {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid transparent;
  background-color: transparent;
  color: #999999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.FloatingCalendar_closeButton__Tpw67:hover {
  background-color: #3a3d42;
  color: #ffffff;
}

.FloatingCalendar_weekdayRow__5TMyw,
.FloatingCalendar_dayGrid__e-s-a {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.FloatingCalendar_weekdayRow__5TMyw {
  padding: 8px 8px 4px 8px;
}

.FloatingCalendar_weekday__TLZ-b {
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #999999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.FloatingCalendar_dayGrid__e-s-a {
  padding: 4px 8px 10px 8px;
  gap: 2px;
}

.FloatingCalendar_day__4-hAN {
  position: relative;
  aspect-ratio: 1 / 1;
  border: 1px solid transparent;
  border-radius: 6px;
  background-color: transparent;
  color: #dddddd;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  gap: 2px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  padding: 0;
}

.FloatingCalendar_day__4-hAN:hover {
  background-color: #2a2d31;
  border-color: #4a4d52;
}

.FloatingCalendar_dayOutside__SbNXe {
  color: #555555;
}

.FloatingCalendar_dayToday__m0dSE {
  border-color: #4a9eff;
  font-weight: 700;
}

.FloatingCalendar_daySelected__q8qTH {
  background-color: #4a9eff;
  color: #ffffff;
  font-weight: 700;
}

.FloatingCalendar_daySelected__q8qTH:hover {
  background-color: #3a8aff;
}

.FloatingCalendar_dayNumber__DbQTK {
  line-height: 1;
}

.FloatingCalendar_dayDots__iIhoS {
  display: flex;
  gap: 2px;
  height: 5px;
  align-items: center;
}

.FloatingCalendar_dayDot__tVckK {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #4a9eff;
}

.FloatingCalendar_daySelected__q8qTH .FloatingCalendar_dayDot__tVckK {
  background-color: #ffffff;
}

/* === Selected day ticket list === */

.FloatingCalendar_ticketList__RXGh2 {
  border-top: 1px solid #444;
  background-color: #1d1f20;
  max-height: 220px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.FloatingCalendar_ticketList__RXGh2::-webkit-scrollbar { width: 8px; }
.FloatingCalendar_ticketList__RXGh2::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
}

.FloatingCalendar_ticketItem__cBTZk {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 9px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.FloatingCalendar_ticketItem__cBTZk:hover {
  background-color: #25272a;
}

.FloatingCalendar_ticketItem__cBTZk:last-child {
  border-bottom: none;
}

.FloatingCalendar_ticketPriority__DxFTc {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}

.FloatingCalendar_ticketInfo__Pf389 {
  flex: 1 1;
  min-width: 0;
}

.FloatingCalendar_ticketTitle__YtAy5 {
  font-size: 13px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.FloatingCalendar_ticketDone__Zkay6 .FloatingCalendar_ticketTitle__YtAy5 {
  color: #999999;
  text-decoration: line-through;
}

.FloatingCalendar_ticketMeta__Bl2o- {
  font-size: 11px;
  color: #888888;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.FloatingCalendar_emptyState__Mga5g {
  padding: 20px 14px;
  text-align: center;
  font-size: 12px;
  color: #777777;
}

.FloatingCalendar_listHeader__kjHQI {
  padding: 8px 14px;
  font-size: 11px;
  font-weight: 600;
  color: #999999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: #1a1c1d;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/components/FloatingCalendar.module.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC;;8DAE4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd;mDACiD;EACjD,gBAAgB;EAChB,uDAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,gEAAgE;EAChE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;;AAErC;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,yDAAiC,UAAU,EAAE;AAC7C;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kDAAkD;EAClD,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,kDAAkD;AACpD","sourcesContent":["/* === Floating Calendar Widget === */\n\n.iconButton {\n  position: fixed;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #181a1b;\n  border: 1px solid #444;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: grab;\n  user-select: none;\n  touch-action: none;\n  z-index: 1000;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);\n  transition: left 0.32s cubic-bezier(0.22, 1, 0.36, 1),\n              top 0.32s cubic-bezier(0.22, 1, 0.36, 1),\n              box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.iconButton:hover {\n  background-color: #23272a;\n  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.35);\n}\n\n.iconButton:active,\n.dragging {\n  cursor: grabbing;\n  transition: none; /* keine Transition waehrend des Ziehens */\n}\n\n.iconButton:focus-visible {\n  outline: 2px solid #4a9eff;\n  outline-offset: 2px;\n}\n\n.icon {\n  font-size: 22px;\n  line-height: 1;\n  pointer-events: none;\n}\n\n.iconBadge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background-color: #4a9eff;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  border: 2px solid #181a1b;\n}\n\n/* === Calendar Panel === */\n\n.panel {\n  position: fixed;\n  z-index: 1001;\n  width: 340px;\n  background-color: #181a1b;\n  border: 1px solid #444;\n  border-radius: 10px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.75);\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  overflow: hidden;\n  animation: popIn 0.16s ease-out;\n}\n\n@keyframes popIn {\n  from { opacity: 0; transform: scale(0.96); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n.panelHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background-color: #23272a;\n  border-bottom: 1px solid #444;\n}\n\n.monthNav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.navButton {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  background-color: transparent;\n  color: #cccccc;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.navButton:hover {\n  background-color: #3a3d42;\n  color: #ffffff;\n}\n\n.monthTitle {\n  font-size: 15px;\n  font-weight: 600;\n  min-width: 150px;\n  text-align: center;\n  text-transform: capitalize;\n}\n\n.closeButton {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  background-color: transparent;\n  color: #999999;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.closeButton:hover {\n  background-color: #3a3d42;\n  color: #ffffff;\n}\n\n.weekdayRow,\n.dayGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.weekdayRow {\n  padding: 8px 8px 4px 8px;\n}\n\n.weekday {\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: #999999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dayGrid {\n  padding: 4px 8px 10px 8px;\n  gap: 2px;\n}\n\n.day {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background-color: transparent;\n  color: #dddddd;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  gap: 2px;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n  padding: 0;\n}\n\n.day:hover {\n  background-color: #2a2d31;\n  border-color: #4a4d52;\n}\n\n.dayOutside {\n  color: #555555;\n}\n\n.dayToday {\n  border-color: #4a9eff;\n  font-weight: 700;\n}\n\n.daySelected {\n  background-color: #4a9eff;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.daySelected:hover {\n  background-color: #3a8aff;\n}\n\n.dayNumber {\n  line-height: 1;\n}\n\n.dayDots {\n  display: flex;\n  gap: 2px;\n  height: 5px;\n  align-items: center;\n}\n\n.dayDot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #4a9eff;\n}\n\n.daySelected .dayDot {\n  background-color: #ffffff;\n}\n\n/* === Selected day ticket list === */\n\n.ticketList {\n  border-top: 1px solid #444;\n  background-color: #1d1f20;\n  max-height: 220px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.ticketList::-webkit-scrollbar { width: 8px; }\n.ticketList::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.25);\n  border-radius: 4px;\n}\n\n.ticketItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 9px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.ticketItem:hover {\n  background-color: #25272a;\n}\n\n.ticketItem:last-child {\n  border-bottom: none;\n}\n\n.ticketPriority {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  margin-top: 5px;\n  flex-shrink: 0;\n}\n\n.ticketInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.ticketTitle {\n  font-size: 13px;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ticketDone .ticketTitle {\n  color: #999999;\n  text-decoration: line-through;\n}\n\n.ticketMeta {\n  font-size: 11px;\n  color: #888888;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.emptyState {\n  padding: 20px 14px;\n  text-align: center;\n  font-size: 12px;\n  color: #777777;\n}\n\n.listHeader {\n  padding: 8px 14px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #999999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background-color: #1a1c1d;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconButton": `FloatingCalendar_iconButton__CUlpI`,
	"dragging": `FloatingCalendar_dragging__XCiMU`,
	"icon": `FloatingCalendar_icon__OY7cs`,
	"iconBadge": `FloatingCalendar_iconBadge__sc3Cg`,
	"panel": `FloatingCalendar_panel__b-axX`,
	"popIn": `FloatingCalendar_popIn__nmZJK`,
	"panelHeader": `FloatingCalendar_panelHeader__9hw2N`,
	"monthNav": `FloatingCalendar_monthNav__L1Htn`,
	"navButton": `FloatingCalendar_navButton__+Ye9E`,
	"monthTitle": `FloatingCalendar_monthTitle__X27KY`,
	"closeButton": `FloatingCalendar_closeButton__Tpw67`,
	"weekdayRow": `FloatingCalendar_weekdayRow__5TMyw`,
	"dayGrid": `FloatingCalendar_dayGrid__e-s-a`,
	"weekday": `FloatingCalendar_weekday__TLZ-b`,
	"day": `FloatingCalendar_day__4-hAN`,
	"dayOutside": `FloatingCalendar_dayOutside__SbNXe`,
	"dayToday": `FloatingCalendar_dayToday__m0dSE`,
	"daySelected": `FloatingCalendar_daySelected__q8qTH`,
	"dayNumber": `FloatingCalendar_dayNumber__DbQTK`,
	"dayDots": `FloatingCalendar_dayDots__iIhoS`,
	"dayDot": `FloatingCalendar_dayDot__tVckK`,
	"ticketList": `FloatingCalendar_ticketList__RXGh2`,
	"ticketItem": `FloatingCalendar_ticketItem__cBTZk`,
	"ticketPriority": `FloatingCalendar_ticketPriority__DxFTc`,
	"ticketInfo": `FloatingCalendar_ticketInfo__Pf389`,
	"ticketTitle": `FloatingCalendar_ticketTitle__YtAy5`,
	"ticketDone": `FloatingCalendar_ticketDone__Zkay6`,
	"ticketMeta": `FloatingCalendar_ticketMeta__Bl2o-`,
	"emptyState": `FloatingCalendar_emptyState__Mga5g`,
	"listHeader": `FloatingCalendar_listHeader__kjHQI`
};
export default ___CSS_LOADER_EXPORT___;
